<label class="custom-toggle">
  <input type="checkbox" [(ngModel)]="checked" (change)="onToggleChange()">
  <span class="slider"></span>
  <span class="icon x-icon">
    <fa-icon [icon]="xIcon"></fa-icon>
  </span>
  <span class="icon check-icon">
    <fa-icon [icon]="checkIcon"></fa-icon>
  </span>
</label>